import React, { Fragment } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Home from "./components/Home";
import Main from "./views/Main";
import Signup from "./views/Signup";
import Terms from "./components/Terms";
import Privacy from "./components/Privacy";
import Affiliate from "./components/Affiliate";

//Auth0
import PrivateRoute from "./components/PrivateRoute";
import Loading from "./components/Loading";
import Footer from './components/Footer';
import Navbar from "./components/Navbar";

import { useAuth0 } from "./react-auth0-spa";
//get Context
import UserContext from "./UserContext";

//my Assets
import 'jquery';

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
initFontAwesome();

function App() {

  const info = {
    userToken: "",
  };

  const { loading, user, getTokenSilently } = useAuth0();

  let usermail;

  if (user) {
    usermail = user.email;
    (async () => {
      const token = await getTokenSilently();
      info.userToken = await token;
      localStorage.setItem("token", info.userToken);
    })()

  }

  if (loading) {
    return <Loading />;
  }

  return (
    <UserContext.Provider value={info}>
      <Router>
        <Fragment>
          <Navbar />
          <Switch>
            <Route path="/" exact component={Home} />
            <PrivateRoute path="/main" exact component={Main} render={() => <Main userMail={usermail} />} />
            <PrivateRoute path="/signup" exact component={Signup} render={() => <Signup userMail={usermail} />} />

            <Route path="/Affiliate" exact component={Affiliate} />
            <Route path="/Privacy" exact component={Privacy} />
            <Route path="/Terms" exact component={Terms} />
          </Switch>
          <Footer />

        </Fragment>
      </Router>
    </UserContext.Provider>
  );
}

export default App;
